import { t } from 'i18next';

import { Button } from '@/components/ui/button';

interface AuthErrorProps {
  onRetry: () => void;
}

const AuthError = ({ onRetry }: AuthErrorProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <p className="text-gray-600 mb-6">{t('An error occurred while signing in. Please try again or contact support if the problem persists.')}</p>
      <Button
        variant="default"
        className="flex gap-2 items-center"
        size="sm"
        onClick={onRetry}
      >
        <span>{t('Retry')}</span>
      </Button>
    </div>
  );
};

export { AuthError };
